module.exports = __webpack_public_path__ + "img/Mailbox2.6bfd3398.svg";